import * as types from "../../../actions/actionTypes/offer/workflow/";
import initialState from "../../initialState";

export default function workflowReducer(state = initialState.currentOffer, action) {
  switch (action.type) {
    case types.LOAD_OFFER_WORKFLOW_SUCCESS:
      return {
        ...state,
        results: action.payload,
        isLoaded: true
      };

    case types.LOAD_OFFER_WORKFLOW_TASKS_SUCCESS: {
      return {
        ...state,
        tasks: [...state.tasks, action.payload]
      };
    }

    default:
      return state;
  }
}
